import React, { useContext } from "react";
import { Container, Grid, makeStyles, Typography, Box } from "@material-ui/core";
import {
	People as PeopleIcon,
	PersonAdd as PersonAddIcon,
	EventBusy as EventBusyIcon,
	Assignment as AssignmentIcon,
} from "@material-ui/icons";

import useTickets from "../../hooks/useTickets";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import StatCard from "../../components/StatCard";
import Chart from "./Chart";

const useStyles = makeStyles((theme) => ({
	container: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(4),
	},
	pageTitle: {
		fontSize: "1.75rem",
		fontWeight: 700,
		marginBottom: theme.spacing(3),
		color: theme.palette.text.primary,
	},
	statsGrid: {
		marginBottom: theme.spacing(4),
	},
	chartCard: {
		padding: theme.spacing(3),
		borderRadius: 10,
		boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
		border: `1px solid ${theme.palette.mode === "light" ? "#F3F4F6" : "#374151"}`,
		backgroundColor: theme.palette.background.paper,
	},
	chartTitle: {
		fontSize: "1.125rem",
		fontWeight: 600,
		marginBottom: theme.spacing(2),
		color: theme.palette.text.primary,
	},
}));

const Dashboard = () => {
	const classes = useStyles();
	const { user } = useContext(AuthContext);

	var userQueueIds = [];
	if (user.queues && user.queues.length > 0) {
		userQueueIds = user.queues.map((q) => q.id);
	}

	const GetTickets = (status, showAll, withUnreadMessages) => {
		const { count } = useTickets({
			status: status,
			showAll: showAll,
			withUnreadMessages: withUnreadMessages,
			queueIds: JSON.stringify(userQueueIds),
		});
		return count;
	};

	// Get ticket counts
	const inAttendance = GetTickets("open", "true", "false");
	const waiting = GetTickets("pending", "true", "false");
	const closed = GetTickets("closed", "true", "false");

	// Calculate total for percentage
	const total = inAttendance + waiting + closed;

	return (
		<Container maxWidth="lg" className={classes.container}>
			<Typography className={classes.pageTitle}>
				{i18n.t("dashboard.title") || "Dashboard"}
			</Typography>

			{/* Statistics Cards */}
			<Grid container spacing={3} className={classes.statsGrid}>
				<Grid item xs={12} sm={6} md={3}>
					<StatCard
						icon={PeopleIcon}
						iconColor="#316AFF"
						iconBgColor="rgba(49, 106, 255, 0.1)"
						value={inAttendance}
						label={i18n.t("dashboard.messages.inAttendance.title")}
						change={total > 0 ? ((inAttendance / total) * 100).toFixed(1) : 0}
						changeLabel="of total"
					/>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<StatCard
						icon={PersonAddIcon}
						iconColor="#F59E0B"
						iconBgColor="rgba(245, 158, 11, 0.1)"
						value={waiting}
						label={i18n.t("dashboard.messages.waiting.title")}
						change={total > 0 ? ((waiting / total) * 100).toFixed(1) : 0}
						changeLabel="of total"
					/>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<StatCard
						icon={EventBusyIcon}
						iconColor="#10B981"
						iconBgColor="rgba(16, 185, 129, 0.1)"
						value={closed}
						label={i18n.t("dashboard.messages.closed.title")}
						change={total > 0 ? ((closed / total) * 100).toFixed(1) : 0}
						changeLabel="of total"
					/>
				</Grid>

				<Grid item xs={12} sm={6} md={3}>
					<StatCard
						icon={AssignmentIcon}
						iconColor="#8B5CF6"
						iconBgColor="rgba(139, 92, 246, 0.1)"
						value={total}
						label="Total Tickets"
						change={12.5}
						changeLabel="vs last month"
					/>
				</Grid>
			</Grid>

			{/* Chart Section */}
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Box className={classes.chartCard}>
						<Typography className={classes.chartTitle}>
							Tickets Overview
						</Typography>
						<Chart />
					</Box>
				</Grid>
			</Grid>
		</Container>
	);
};

export default Dashboard;